/**
 * Константы для работы с картой MapLibre
 */

/** Базовый путь к локальным данным карты */
export const MAP_DATA_BASE_PATH = '/map-data'

/** Дефолтный размер тайла для raster-источников */
export const DEFAULT_TILE_SIZE = 256

/** Дефолтная прозрачность растровых слоёв */
export const DEFAULT_RASTER_OPACITY = 1

/** Префикс протокола для COG */
export const COG_PROTOCOL_PREFIX = 'cog://'

/** Префикс протокола для PMTiles */
export const PMTILES_PROTOCOL_PREFIX = 'pmtiles://'

/** URL-шаблон тайлов Esri World Imagery */
export const ESRI_WORLD_IMAGERY_URL =
  'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'

/** Максимальный зум, на котором у Esri есть валидные тайлы (выше растягиваем последние) */
export const ESRI_WORLD_IMAGERY_MAX_ZOOM = 19

/** Атрибуция для Esri World Imagery (рекомендуется отображать на карте) */
export const ESRI_WORLD_IMAGERY_ATTRIBUTION =
  '© Esri, Maxar, Earthstar Geographics, and the GIS User Community'
